import { useMemo } from "react";
import { SCREEN_WIDTH_DESKTOP } from "../../constants/layout";
import { useWindowDimensions } from "./useWindowDimensions";
export const useIsDesktop = () => {
    const { width } = useWindowDimensions();
    return useMemo(() => width >= SCREEN_WIDTH_DESKTOP, [width]);
};
